import { getAuthActions, getRefreshToken } from '@core-frontend/core-frontend';
import { toast } from 'react-toastify';

import { refreshTokenAsync } from '@/pages/auth/api';
import { logout } from '@/pages/auth/model/logout';

export const refreshTokenAndUpdateStore = async (): Promise<string> => {
  const actions = getAuthActions();
  const refreshToken = getRefreshToken();

  try {
    if (!refreshToken) throw new Error('No refresh token available');

    const data = await refreshTokenAsync({ refreshToken });

    actions.setTokens(data.access_token, refreshToken);

    return data.access_token;
  } catch (error) {
    toast.error(`Token refresh failed: ${error}`, {
      position: 'top-center',
    });
    logout();
    throw error;
  }
};
